type urlType = {
  label: string;
  value: string;
};

export const isAllUnique = (label: string) => (values: urlType[]) => {
  const unique = values
    .map(v => v.label)
    .filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

  if (unique.length === values.length) {
    return undefined;
  }

  return label;
};
